import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=7d2af744&scoped=true&"
import script from "./CreateProduct.vue?vue&type=script&lang=js&"
export * from "./CreateProduct.vue?vue&type=script&lang=js&"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=7d2af744&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2af744",
  null
  
)

export default component.exports